import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default defineComponent({
  name: 'SearchItem',
  components: {
    NuxtLinkCustom: NuxtLinkCustom,
    AzIcon: AzIcon
  },
  props: {
    link: {
      type: [String, Object],
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  setup: function setup() {}
});